<template>
  <div class="credit">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @currentChange="currentChange"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
        @dblclickEvent="dblclickEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'contractStatus'">
              {{ requestStatusData[scope.row[item.field]] }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/logisticsCenter/warehouseContract.js';
  import DataBaseAPI from '@/api/dataBase';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import status from '@/common/js/status';
  import tableMixins from '@/common/mixins/table.js';

  export default {
    components: {
      SiruiTable,
      SiruiSearch,
    },
    name: 'logisticsContractList',
    mixins: [tableMixins],
    data() {
      return {
        load: false,
        img: './static/img/tips.png',
        contractType: '02',
        query: {
          contractNo: null,
          warehouse: null,
          signStartDate: null,
          signEndDate: null,
          contractStatus: null,
          contractEnterpriseNo: null,
        },
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        requestStatusData: [],
        requestStatusList: [],
        rowData: {}, //被选中的列
        columnList: [],
        //表格显示字段
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'contractNo',
            title: 'warehouseContract.table.contractNo',
            visible: true,
            // sortable: true
          },
          {
            field: 'contractStatus',
            title: 'warehouseContract.table.contractStatus',
            visible: true,
          },
          {
            field: 'contractEnterpriseName',
            title: 'warehouseContract.table.contractEnterpriseNo',
            visible: true,
          },
          { field: 'signDate', title: 'warehouseContract.table.signDate', visible: true },
          { field: 'valideDateTo', title: 'warehouseContract.table.valideDateTo', visible: true },
          {
            field: 'contractCreatePersonName',
            title: 'warehouseContract.table.createBy',
            visible: true,
          },
          {
            field: 'goodsControlAmount',
            title: 'warehouseContract.table.goodsControlAmount',
            visible: true,
          },
          { field: 'contractMark', title: 'warehouseContract.table.contractMark', visible: true },
        ],
      };
    },
    computed: {
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'contractNo',
            name: this.$t('warehouseContract.search.contractNo'),
            type: 'input',
            placeholder: this.$t('warehouseContract.search.contractNoPlaceholder'),
            options: this.partnerTypeList,
          },
          {
            type: 'searchTableSpec',
            prop: 'warehouse',
            isMultiple: true,
            name: this.$t('warehouseContract.search.contractEnterpriseNo'),
            searchType: 'warsehouseService',
            extraData: { partnerTypes: 'HZHB07,HZHB02,HZHB03' },
          },
          {
            prop: 'signStartDate',
            name: this.$t('warehouseContract.search.signDateStart'),
            type: 'startDaterangePicker',
            placeholder: this.$t('warehouseContract.search.signDateStartPlaceholder'),
          },
          {
            prop: 'signEndDate',
            name: this.$t('warehouseContract.search.signDateEnd'),
            type: 'endDaterangePicker',
            placeholder: this.$t('warehouseContract.search.signDateEndPlaceholder'),
          },
          {
            prop: 'contractStatus',
            name: this.$t('warehouseContract.search.contractStatus'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('warehouseContract.search.contractStatusPlaceholder'),
            options: this.requestStatusList,
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
      this.getButtonList();
      this.getDic();
    },
    methods: {
      //获取字典值
      getDic() {
        //状态
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'request_status',
            tenantCode: this.userInfo.userInfo.tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.requestStatusList = res.data.data;
              for (var item of res.data.data) {
                this.requestStatusData[item['value']] = item['label'];
              }
            }
          });
      },
      //获取数据
      getData() {
        this.load = true;
        const query = this.$refs.siruiSearch.query;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        query.companyCode = this.userInfo.userInfo.companyCode;
        if (query.warehouse && query.warehouse.length > 0) {
          query.contractEnterpriseNo = query.warehouse[0].partnerCode;
        } else {
          query.contractEnterpriseNo = null;
        }
        delete query.warehouse;
        query.contractType = this.contractType;
        this.$axios.post(API.CONTRACT_LIST_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //表格选中事件
      currentChange(row) {
        if (JSON.stringify(this.rowData) == '{}' || this.rowData.id != row.id) {
          this.rowData = row;
        } else if (this.rowData.id == row.id) {
          this.rowData = {};
        }
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        //新增
        if (type === 'add') {
          this.add();
        } else if (type === 'del') {
          //删除
          if (
            this.multipleSelection.length === 1 &&
            this.multipleSelection[0].contractStatus == 'ZT04'
          ) {
            this.del();
          } else {
            if (this.multipleSelection.length === 0) {
              this.noSelectData();
            } else {
              this.$message({
                showClose: true,
                message: this.$t('warehouseContract.table.deleteMessage'),
                type: 'error',
              });
            }
          }
        } else if (type === 'inabled') {
          //启用
          if (
            this.multipleSelection.length === 1 &&
            this.multipleSelection[0].contractStatus == 'ZT04'
          ) {
            this.del('ZT03');
          } else {
            if (this.multipleSelection.length === 0) {
              this.noSelectData();
            } else {
              this.$message({
                showClose: true,
                message: this.$t('warehouseContract.table.inableMessage'),
                type: 'error',
              });
            }
          }
        } else if (type === 'disabled') {
          //禁用
          if (
            this.multipleSelection.length === 1 &&
            this.multipleSelection[0].contractStatus == 'ZT03'
          ) {
            this.del('ZT04');
          } else {
            if (this.multipleSelection.length === 0) {
              this.noSelectData();
            } else {
              this.$message({
                showClose: true,
                message: this.$t('warehouseContract.table.disabledMessage'),
                type: 'error',
              });
            }
          }
        } else if (type === 'quit') {
          //放弃
          if (
            this.multipleSelection.length === 1 &&
            this.multipleSelection[0].contractStatus == 'ZT05'
          ) {
            this.quit();
          } else {
            if (this.multipleSelection.length === 0) {
              this.noSelectData();
            } else {
              this.$message({
                showClose: true,
                message: this.$t('warehouseContract.table.quitMessage'),
                type: 'error',
              });
            }
          }
        } else if (type === 'edit') {
          if (this.multipleSelection.length === 0) {
            this.noSelectData();
          } else if (this.multipleSelection.length > 1) {
            this.$message({
              showClose: true,
              message: this.$t('applicationCredit.msg.onlyCanSelectNoEdit'),
              type: 'error',
            });
          } else if (
            this.multipleSelection.length === 1 &&
            (this.multipleSelection[0].contractStatus === status.ZT02 ||
              this.multipleSelection[0].contractStatus === status.ZT04)
          ) {
            this.$message({
              showClose: true,
              message: this.$t('warehouseContract.table.canNotEditMessage'),
              type: 'error',
            });
          } else {
            let path = {
              path: '/logistics/logisticsContractEdit',
              name: 'logisticsContractEdit',
              meta: {
                keepAlive: true,
                title: '信用额度修改',
              },
              query: {
                version: this.multipleSelection[0].version,
                contractNo: this.multipleSelection[0].contractNo,
              },
            };
            this.$store.dispatch('tagsView/addTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path);
              });
            });
          }
        } else {
          //导出
          this.export();
        }
      },
      //没有选择数据提示
      noSelectData() {
        this.$message({
          showClose: true,
          message: this.$t('xTable.noSelectData'),
          type: 'error',
        });
      },
      //新增
      add() {
        let path = {
          path: '/logistics/logisticsContractAdd',
          name: 'logisticsContractAdd',
          meta: {
            keepAlive: true,
            title: '信用额度新增',
          },
          query: {},
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //导出
      export() {
        const query = this.$refs.siruiSearch.query;
        query.companyCode = this.userInfo.userInfo.companyCode;
        if (query.warehouse && query.warehouse.length > 0) {
          query.contractEnterpriseNo = query.warehouse[0].storageCode;
        }
        delete query.warehouse;
        query.contractType = this.contractType;
        this.$axios.post(API.ECXPORT_CONTRACT_API, query).then((res) => {
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          }
        });
      },
      //放弃
      quit() {
        this.$confirmAction(this.$t('confirm.remove'), this.$t('confirm.removeContent'))
          .then(() => {
            let params = {
              contractType: this.contractType,
              version: this.multipleSelection[0].version,
              contractNo: this.multipleSelection[0].contractNo,
              contractUpdatePersonName: this.userInfo.userInfo.userName,
            };
            this.$axios.post(API.QUIT_CONTRACT_API, params).then((res) => {
              if (0 == res.data.code) {
                //如果操作成功，直接返回列表
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.getData();
              } else {
                //如果有错误返回，提示信息
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //删除/启用/禁用
      del(type) {
        let msg = '';
        let content = '';
        if (type == 'ZT04') {
          msg = this.$t('confirm.forbid');
          content = this.$t('confirm.forbidContent');
        } else if (type == 'ZT03') {
          msg = this.$t('confirm.lift');
          content = this.$t('confirm.liftContent');
        } else {
          msg = this.$t('confirm.delete');
          content = this.$t('confirm.content');
        }
        this.$confirmAction(msg, content)
          .then(() => {
            let params = {
              admin: this.userInfo.userInfo.adminFlag,
              contractType: this.contractType,
              version: this.multipleSelection[0].version,
              contractNo: this.multipleSelection[0].contractNo,
              contractUpdatePersonName: this.userInfo.userInfo.userName,
            };
            if (type) {
              params.contractStatus = type;
            }
            this.$axios.post(API.DELETE_CONTRACT_API, params).then((res) => {
              if (0 == res.data.code) {
                //如果操作成功，直接返回列表
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.getData();
              } else {
                //如果有错误返回，提示信息
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //双击事件
      dblclickEvent(value) {
        let path = {
          path: '/logistics/logisticsContractDetail',
          name: 'logisticsContractDetail',
          meta: {
            keepAlive: false,
          },
          query: { contractNo: value.row.contractNo, canEdit: '0' },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      /**页面必要代码End */
    },
  };
</script>
